import bem from 'utils/bem';

export const block = bem('audiogram-destination-modal');
export const chooseDestinationContentsBlock = bem(
  'choose-destination-modal-contents',
);
export const videoTypesModalContentsBlock = bem('video-types-modal-contents');
